const PUBLIC_ROUTES = {
  login: '/login',
};

const ALL = {
  home: '/',
  profile: '/profile',
  scheduler: '/scheduler',
  psychologists: '/psychologists',
  psychologist: (id) => `/psychologists/${id}`,
  nutritionists: '/nutritionists',
  nutritionist: (id) => `/nutritionists/${id}`,
  consultations: '/consultations',
  consultation: (id) => `/consultations/${id}`,
  nutritionConsultations: '/nutrition-consultations',
  nutritionConsultation: (id) => `/nutrition-consultations/${id}`,
  nutritionAgora: (id) => `/nutrition-consultations/${id}/agora`,
  zoom: (id) => `/consultations/${id}/zoom`,
  agora: (id) => `/consultations/${id}/agora`,
  users: '/users',
  user: (id) => `/users/${id}`,
  checkouts: '/checkouts',
  callbacks: '/callbacks',
  feedbacks: '/feedbacks',
  nutritionFeedbacks: '/nutrition-feedback',
  pages: '/pages',
  blog: '/blog',
  centers: '/centers',
  problems: '/problems',
  filters: '/filters',
  nutritionFilters: '/nutrition-filters',
  promos: '/promos',
  singlePage: (id) => `/pages/${id}`,
  singlePageCreate: (id) => (!!id ? `/pages/create?copyId=${id}` : `/pages/create`),
  seo: '/seo',
  singleSeoPage: (slug) => `/seo/${slug}`,
  singleSeoPageCreate: `/seo-create`,
  features: '/features',
  nutritionFeatures: '/nutrition-features',
  banners: '/banners',
};

export const ROUTES = {
  ...ALL,
  ...PUBLIC_ROUTES,
};
